__turbopack_context__.v({
  "footer": "FormField-module__QDhe8q__footer",
  "label": "FormField-module__QDhe8q__label",
  "root": "FormField-module__QDhe8q__root",
});
